import KpiDateFilterBar from '../../components/KpiDateFilterBar';
import PerformanceKpiTable from '../../components/PerformanceKpiTable';
import PerformanceKpiTiles from '../../components/PerformanceKpiTiles';
import { useKpiDateFilter } from '../../utils/kpiDateFilter';

export default function SalesKpiAnalytics() {
    const dateFilter = useKpiDateFilter();

    return (
        <div className="space-y-5">
            <div>
                <h1 className="text-2xl font-extrabold">KPI analytics</h1>
                <p className="text-sm text-ink-500 mt-1">
                    Your funnel KPIs by stage from the daily meetings sheet — filter by today, a single date, or a custom range.
                </p>
            </div>
            <KpiDateFilterBar {...dateFilter} />
            <PerformanceKpiTiles scope="personal" embedded showFunnel hideActions dateParams={dateFilter.apiParams} periodLabel={dateFilter.label} />
            <PerformanceKpiTable scope="personal" dateParams={dateFilter.apiParams} hideDateFilter />
        </div>
    );
}
